module.exports = __webpack_public_path__ + "img/key 3.73d091a6.png";